"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchDeliveryOptions = void 0;
const module_cart_b2ag_interfaces_1 = require("@invivodf/module-cart-b2ag-interfaces");
const searchDeliveryOptions = (searchHomeDeliveryOptions, searchPickupPointDeliveryOptions, searchClickAndCollectDeliveryOptions) => async ({ logisticRoute, ...parameters }) => {
    switch (logisticRoute) {
        case module_cart_b2ag_interfaces_1.LogisticRoute.HomeDelivery:
            return searchHomeDeliveryOptions(parameters);
        case module_cart_b2ag_interfaces_1.LogisticRoute.PickupPoint:
            return searchPickupPointDeliveryOptions(parameters);
        case module_cart_b2ag_interfaces_1.LogisticRoute.ClickAndCollect:
            return searchClickAndCollectDeliveryOptions(parameters);
        default:
            throw new Error(`Unsupported logistic route: ${logisticRoute}`);
    }
};
exports.searchDeliveryOptions = searchDeliveryOptions;
